// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.form-content-wrapper');
  }

  @on({
    event: 'click',
    selector:
      "input[name='company_stock_option_right_type_form[right_type_attributes][so_category_ids][]']",
  })
  onClickSoCategoryIdsFields(event: any) {
    removeInvalidFeedback($(event.target));
  }
}
